import React from 'react'
import { COMMENT_POST } from '../../api';
import Error from '../../Components/Helper/Error';
import {ReactComponent as Enviar} from '../../Assets/enviar.svg';
import useFetch from '../../Hooks/useFetch';
import styles from './PhotoCommentForm.module.css';
const PhotoCommentsForm = ({id, setComments, single }) => {
  const [comment, setComment] = React.useState('');
  const {request, error} = useFetch();
  async function handleSubmit(event){
    event.preventDefault();
    const {url, options} = COMMENT_POST(id, {comment});
    const {response, json} = await request(url, options);
    if(response.ok){
      setComment('');
      setComments((comments) => [...comments, json]);
    }
  }
  return (
    <form onSubmit={handleSubmit  } className={`${styles.form} ${single ? styles.single : ''}`}>
      <textarea
        className={styles.textarea}
        id="comment"
        name="comment"
        placeholder="Digite um comentario" 
        value={comment}
        onChange={({target}) => setComment(target.value)}
      />
      <button className={styles.button}><Enviar /></button>
      <Error error={error}/>
    </form>
  )
}

export default PhotoCommentsForm;
